(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qerije-header"]) return;
  try {
    

function bindCoutureMenu(scope) {
  scope.querySelectorAll('.q-mobile-menu').forEach(menu => {
    if(menu.dataset.bound) return;
    menu.dataset.bound='true';
    menu.addEventListener('click',event=>{if(event.target.closest('a')) menu.open=false;});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
    menu.addEventListener('focusout',event=>{if(!menu.contains(event.relatedTarget)) menu.open=false;});
  });
}
bindCoutureMenu(document);
document.addEventListener('shopify:section:load',event=>bindCoutureMenu(event.target));


  } catch(e) { console.error(e); }
})();
})();
